webpackJsonp([15400075347947],{

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _privacy_policyModule = __webpack_require__(253);
	
	var _privacy_policyModule2 = _interopRequireDefault(_privacy_policyModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var privacy_policy = function privacy_policy() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _privacy_policyModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.main_heading },
	        'Privacy Policy '
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.ite_heading },
	        'Effective date: June 21, 2019'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'First WalkIn Technologies Pvt Ltd ("us", "we", or "our") operates the uptyme website and the uptyme mobile application (hereinafter referred to as the "Service").'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Information Collection And Use'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'We collect several different types of information for various purposes to provide and improve our Service to you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.ite_heading },
	        'Types of Data Collected :'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.under_sec_heading },
	        'Personal Data'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.indent },
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'Email address'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'First name and last name'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'Phone number'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'Cookies and Usage Data'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.under_sec_heading },
	        'Usage Data'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device ("Usage Data").'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'This Usage Data may include information such as your computer\'s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'When you access the Service with a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.under_sec_heading },
	        'Tracking & Cookies Data'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service. You can learn more how to manage cookies in the Browser Cookies Guide.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.under_sec_heading },
	        'Examples of Cookies we use:'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.indent },
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'Session Cookies. We use Session Cookies to operate our Service.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'Preference Cookies. We use Preference Cookies to remember your preferences and various settings.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'Security Cookies. We use Security Cookies for security purposes.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Use of Data'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'uptyme.ai uses the collected data for various purposes:'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.indent },
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To provide and maintain the Service'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To notify you about changes to our Service'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To allow you to participate in interactive features of our Service when you choose to do so'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To provide customer care and support'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To provide analysis or valuable information so that we can improve the Service'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To monitor the usage of the Service'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To detect, prevent and address technical issues'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Transfer Of Data'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'Your information, including Personal Data, may be transferred to \u2014 and maintained on \u2014 computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'If you are located outside British Indian Ocean Territory and choose to provide information to us, please note that we transfer the data, including Personal Data, to British Indian Ocean Territory and process it there.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'uptyme.ai will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Disclosure Of Data'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.ite_heading },
	        'Legal Requirements'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'uptyme.ai may disclose your Personal Data in the good faith belief that such action is necessary to:'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.indent },
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To comply with a legal obligation'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To protect and defend the rights or property of uptyme.ai'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To prevent or investigate possible wrongdoing in connection with the Service'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To protect the personal safety of users of the Service or the public'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: _privacy_policyModule2.default.normal_text },
	          'To protect against legal liability'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Security Of Data'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Service Providers'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'We may employ third party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Analytics'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'We may use third-party Service Providers to monitor and analyze the use of our Service.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'TODO: Link to any analytics service we might use'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Links To Other Sites'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party\'s site. We strongly advise you to review the Privacy Policy of every site you visit'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Children\'s Privacy'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'Our Service does not address anyone under the age of 18 ("Children").'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Changes To This Privacy Policy'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.sec_heading },
	        'Contact Us'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'If you have any questions about this Privacy Policy, please contact us:'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: _privacy_policyModule2.default.normal_text },
	        'By email: uptyme@getwalk.in'
	      )
	    )
	  );
	};
	
	exports.default = privacy_policy;
	module.exports = exports['default'];

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-pages----privacy_policy-module---container---1Lu-h","normal_text":"src-pages----privacy_policy-module---normal_text---35TgB","main_heading":"src-pages----privacy_policy-module---main_heading---3nTAL","sec_heading":"src-pages----privacy_policy-module---sec_heading---3a3G0","under_sec_heading":"src-pages----privacy_policy-module---under_sec_heading---1rdWl","ite_heading":"src-pages----privacy_policy-module---ite_heading---llX5O","indent":"src-pages----privacy_policy-module---indent---3OQ6S"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-js-e680aac3090a96e197e4.js